<template>
    <v-card v-if="model.id" class="elevation-2">
      <v-card-title class="text-h5">
        <h2 class="font-weight-bold text--primary"> Seguimiento </h2>
      </v-card-title>
      <v-card-subtitle class="title text--black font-weight-black font-weight-bold">
          {{`[ ${model.folio} ]`}}
      </v-card-subtitle>
      <v-tabs v-model="tab" background-color="primary" align-with-title dark>
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab href="#General">General</v-tab>
        <v-tab href="#Factura">Factura</v-tab>
        <!-- <v-tab href="#two" @click="viewEquipo()">Equipo Computo</v-tab> -->
        <v-tab href="#Movimientos" @click="viewMovs(model.folio)">Bitácora de Movimientos</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
          <!-- General -->
          <v-tab-item value="General">
            <v-card width="auto" outlined>
              <v-card-text>

<v-row dense  v-if="model.area_solicitante">
    <v-col cols="12" sm="12" md="12">
        <h3>Datos RM</h3>
        <hr>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Area Solicitante: </label>
        <p class="font-weight-bold text--secondary">
            {{model.area_solicitante.nombre}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Unidad: </label>
        <p class="font-weight-bold text--secondary">
            {{model.unidad.nombre}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha Orden Salida: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.fOrdenSalida}}
        </p>
    </v-col>
    <v-col v-if="model.contrato" cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Contrato: </label>
        <p class="font-weight-bold text--secondary">
            {{model.contrato.folio}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Proceso de Adjudicacion: </label>
        <p class="font-weight-bold text--secondary">
            {{model.tipo_proceso.nombre}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Tipo Recurso: </label>
        <p class="font-weight-bold text--secondary">
            {{model.f_f.nombre}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">UBP (Unidad Basica de Proyecto): </label>
        <p v-for="(u) in model.u_b_p" :key="u.id" class="font-weight-bold text--secondary">
            {{u.nombre}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Folio de respuesta de Suficiencia Presupuestal: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.folio_respuesta_suficiencia_presupuestal}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Monto autorizado: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.descripcion.monto_autorizado}}
        </p>
    </v-col>
    <v-col v-if="model.comprador" cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Comprador (Colaborador): </label>
        <p class="font-weight-bold text--secondary">
            {{model.comprador.NombreCompleto}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de turnado a la Subdirección Financiera: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.fTurnadoSubdireccionFinanciera}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Póliza Comprometido: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.poliza_comprometido}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Polizada Devengado: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.poliza_devengado}}
        </p>
    </v-col>
</v-row>

<v-row dense v-if="model.descripcion">
    <v-col cols="12" sm="12" md="12">
        <h3>Datos RF</h3>
        <hr>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Póliza de ejercicio: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.poliza_ejercido}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Póliza de Pagado: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.poliza_pagado}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Importe pagado: </label>
        <p class="font-weight-bold text--secondary">
           $ {{model.descripcion.importe_pagado}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Fecha de pagado: </label>
        <p class="font-weight-bold text--secondary">
            {{ model.descripcion.fPagado }}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.banco_emisor">
        <label class="font-weight-bold subtitle-1 text--primary">Banco Emisor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.banco_emisor.nombre}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Cuenta Bancaria del Emisor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.cuenta_bancaria_emisora}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Clabe Bancaria del Emisor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.clabe_bancaria_emisora}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.banco_receptor">
        <label class="font-weight-bold subtitle-1 text--primary">Banco Receptor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.banco_receptor.nombre}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Cuenta Bancaria del Receptor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.cuenta_bancaria_receptora}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Clabe Bancaria del Receptor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.clabe_bancaria_receptora}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.factura.proveedor.datos_bancarios.es_linea_captura === 'si'">
        <label class="font-weight-bold subtitle-1 text--primary">Linea de captura: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.linea_captura}}
        </p>
    </v-col>
</v-row>
</v-card-text>
          </v-card>
          </v-tab-item>
          <!-- Factura -->
          <v-tab-item value="Factura">
            <v-card width="auto" outlined>
                <v-card-text>

<v-row dense>
    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Folio fiscal: </label>
        <p class="font-weight-bold text--secondary">
            {{model.factura.descripcion.folio_fiscal}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Numero de factura: </label>
        <p class="font-weight-bold text--secondary">
            {{model.factura.descripcion.numero_factura}}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Concepto general: </label>
        <p class="font-weight-bold text--secondary">
            {{model.factura.descripcion.concepto_general}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="6">
        <label class="font-weight-bold subtitle-1 text--primary">Proveedor: </label>
        <p class="font-weight-bold text--secondary">
            {{model.factura.proveedor.rfc }} -
            {{model.factura.proveedor.nombre }}
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Subtotal: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.factura.descripcion.subtotal_impuestos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Impuestos: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.factura.descripcion.impuestos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.factura.descripcion.descuento">
        <label class="font-weight-bold subtitle-1 text--primary">Descuento: </label>
        <p class="font-weight-bold text--secondary">
            {{model.factura.descripcion.descuento}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4" v-if="model.factura.descripcion.impuestos_retenidos">
        <label class="font-weight-bold subtitle-1 text--primary">ISR: </label>
        <p class="font-weight-bold text--secondary">
            {{model.factura.descripcion.impuestos_retenidos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="4">
        <label class="font-weight-bold subtitle-1 text--primary">Total con impuestos: </label>
        <p class="font-weight-bold text--secondary">
            $ {{model.factura.descripcion.total_con_impuestos}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="12">
        <label class="font-weight-bold subtitle-1 text--primary">Partidas: </label>
        <p v-for="(p) in model.factura.partidas" :key="p.id" class="font-weight-bold text--secondary">
            {{p.cuenta}} - {{p.nombre}} - ${{p.pivot.monto}}
        </p>
    </v-col>
    <v-col cols="12" sm="12" md="12" v-if="model.descripcion.retencion">
        <label class="font-weight-bold subtitle-1 text--primary">Retencion: </label>
        <p class="font-weight-bold text--secondary">
            {{model.descripcion.retencion}} %
        </p>
    </v-col>

    <v-col cols="12" sm="12" md="12" v-if="model.tipo_contratacion">
        <label class="font-weight-bold subtitle-1 text--primary">Tipo de contratacion: </label>
        <p class="font-weight-bold text--secondary">
            {{model.tipo_contratacion.nombre}}
        </p>
    </v-col>
</v-row>
</v-card-text>
          </v-card>
          </v-tab-item>
          <!-- Inventario -->
          <v-tab-item value="two">
            <v-card width="auto" outlined>
              <v-card-text>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Bitacorra -->
          <v-tab-item value="Movimientos">
            <v-card width="auto" outlined>
              <v-card-text>
                <v-row dense>
                  <v-col v-if="showMovs" cols="12">
                    <ViewMovementsField :itemAction="movs" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!--
    <v-card v-if="model.id" class="elevation-2">
      <v-card-text>
      </v-card-text>
    </v-card>
  -->
  </template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model'],
  data: () => ({
    tab: 0,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: false,
    showEq: false,
    itemInsumos: {}
  }),
  components: {
    ViewMovementsField
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    viewEquipo () {
    /*
        if (this.model.descripcion.equipo) return
        this.showEq = false
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.urlGetServiceActionTwo({ url: router, params: `/${this.model.descripcion.inventario.caracteristicas.familia_id}`, replace: '/{id}' })
        setTimeout(() => { this.showEq = true }, 200)
    */
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  },
  watch: {
    model (obj) {
      this.tab = 0
    }
  }
}
</script>
<style>
</style>
